import { render } from "./AddWard.vue?vue&type=template&id=4ca42f6b&scoped=true"
import script from "./AddWard.vue?vue&type=script&lang=js"
export * from "./AddWard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca42f6b"]])

export default __exports__